<template>
	<div>
		<right-panel :datas="mySqlDetailObj" @onClose="onClose()" ref="my-sql-apply-modal" :hideFooter="mySqlDetailObj && mySqlDetailObj.isHideFooter">
			<div slot="header" v-if="mySqlDetailObj">
				<div v-if="mySqlDetailObj.viewType === 'my'"><translate>The Details Of My Application</translate></div>
				<div v-if="mySqlDetailObj.viewType !== 'my'"><translate>Show The Details Of The Application</translate></div>
			</div>
			<div slot="content" v-if="mySqlDetailObj">
				<div class="mySqlDatail">
					<el-row type="flex" v-if="mySqlDetailObj.viewType === 'my' && mySqlDetailObj.status !== 'approving'">
						<el-col :span="8"><translate>Approver</translate><span>:</span></el-col>
						<el-col :span="10" :offset="2">{{ mySqlDetailObj.approved_account.name }} ({{ mySqlDetailObj.approved_account.account }})</el-col>
					</el-row>
					<el-row type="flex" v-if="mySqlDetailObj.viewType !== 'my'">
						<el-col :span="10" class="view-right"><translate>Applyer</translate><span>:</span></el-col>
						<el-col :span="10">{{ mySqlDetailObj.application_account.name }}({{ mySqlDetailObj.application_account.account }})</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="8"><translate>Resource</translate><span>:</span></el-col>
						<el-col :span="10" :offset="2">{{ mySqlDetailObj.resource.name }}({{ mySqlDetailObj.resource.ip_address }})</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="8"><translate>Target DataBase</translate><span>:</span></el-col>
						<el-col :span="10" :offset="2">{{ mySqlDetailObj.database || '-' }}</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="8"><translate>Project</translate><span></span></el-col>
						<el-col :span="10" :offset="2" v-if="mySqlDetailObj.project">{{ mySqlDetailObj.project.project_name }}</el-col>
						<el-col :span="10" :offset="2" v-if="!mySqlDetailObj.project">-</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="8"><translate>Status</translate><span>:</span></el-col>
						<el-col :span="10" :offset="2">{{ sqlApplyStatusText[mySqlDetailObj.status] || mySqlDetailObj.status }}</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="8"><translate>Create Time</translate><span>:</span></el-col>
						<el-col :span="10" :offset="2">{{ (mySqlDetailObj.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="8"><translate>SQL:</translate></el-col>
						<el-col :span="10" :offset="2">{{ mySqlDetailObj.sql }}</el-col>
						<el-col :span="3">
							<img style="width: 17px; cursor: pointer; margin-right: 5px" src="../../../../static/images/apply/preview.png" alt="" @click="previewSQL()" />
							<img v-clipboard:copy="mySqlDetailObj.sql" v-clipboard:success="copySuccess" style="width: 17px; cursor: pointer" src="../../../../static/images/apply/copy.png" alt="" />
						</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="8"><translate>Comment</translate><span>:</span></el-col>
						<el-col :span="10" :offset="2">{{ mySqlDetailObj.comment }}</el-col>
					</el-row>
					<el-row type="flex" v-if="mySqlDetailObj.status === 'failed'">
						<el-col :span="8"><translate>reason</translate><span>:</span></el-col>
						<el-col :span="10" :offset="2">{{ mySqlDetailObj.result ? mySqlDetailObj.result : 'Unknown cause' }}</el-col>
					</el-row>
				</div>
			</div>
			<div slot="footer" class="detail-btn">
				<div v-if="mySqlDetailObj">
					<el-button v-if="mySqlDetailObj.viewType === 'my' && mySqlDetailObj.status === 'approving'" type="primary" @click="cancelSqlApply(mySqlDetailObj.id)">
						<translate>Cancel the application</translate>
					</el-button>
					<el-button v-if="mySqlDetailObj.viewType === 'approve' && mySqlDetailObj.status === 'approving'" type="primary" @click="doExecute(mySqlDetailObj.id)">
						<translate>Execute</translate>
					</el-button>
					<el-button v-if="mySqlDetailObj.viewType === 'approve' && mySqlDetailObj.status === 'approving'" type="primary" @click="doReject(mySqlDetailObj.id)">
						<translate>Reject</translate>
					</el-button>
				</div>
			</div>
		</right-panel>
	</div>
</template>
<script>
import STORE_CONST from '../../../store/consts.js'
import RightPanel from '../../common/right-panel'
export default {
	name: 'mySqlView',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			isShow: false,
			mySqlDetailObj: null,
			type: '',
			sqlApplyStatusText: {
				approving: this.$gettext('approving'),
				approve_wait_result: this.$gettext('approved'),
				rejected: this.$gettext('rejected'),
				approved: this.$gettext('success'),
				failed: this.$gettext('failed'),
			},
		}
	},
	methods: {
		onClose() {
			this.mySqlDetailObj = null
			this.$emit('onClosePanel')
		},
		previewSQL() {
			this.$emit('onShowModal', { name: 'previewSQL', data: this.mySqlDetailObj })
		},
		copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success',
			})
		},
		cancelSqlApply(id) {
			this.$confirm(this.$gettext('Are you sure to delete current application?'), this.$gettext('Delete SQL application confirm'), {
				confirmButtonText: this.$gettext('OK'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				this.$store.dispatch(STORE_CONST.REVIEW.DELETE_SQL_APPLY, id).then((res) => {
					this.$notify({
						type: 'success',
						message: this.$gettext('Cancel successfully!'),
					})
					this.$emit('viewCallback')
					this.$emit('onClosePanel')
				})
			})
		},
		doExecute(id) {
			const params = {
				application_id: id,
			}
			this.$confirm(this.$gettext('Are you sure to execute current SQL?'), this.$gettext('Execute SQL application confirm'), {
				confirmButtonText: this.$gettext('OK'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				this.$store.dispatch(STORE_CONST.REVIEW.EXECUTE_SQL_APPLICATION, params).then((res) => {
					this.$notify({
						type: 'success',
						message: this.$gettext('Submit success, you can check result later.'),
					})
					this.$emit('viewCallback')
					this.$emit('onClosePanel')
				})
			})
		},
		doReject(id) {
			console.log('doreject')
			this.$confirm(this.$gettext('Are you sure to reject current application?'), this.$gettext('Reject SQL application confirm'), {
				confirmButtonText: this.$gettext('OK'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				this.$store.dispatch(STORE_CONST.REVIEW.REJECT_SQL_APPLICATION, id).then((res) => {
					this.$emit('viewCallback')
					this.$emit('onClosePanel')
				})
			})
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				console.log('newVal', newVal)
				if (this.mySqlDetailObj) {
					this.mySqlDetailObj = null
					setTimeout(() => {
						console.log('items', this.items)
						this.mySqlDetailObj = this.items
						this.isHideFooter = newVal.isHideFooter
					}, 300)
				} else {
					this.mySqlDetailObj = this.items
					this.isHideFooter = newVal.isHideFooter
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
.mySqlDatail {
	padding: 15px;
	.el-col {
		word-wrap: break-word;
	}
	.el-col-8 {
		text-align: right;
	}
	.el-row {
		padding-top: 10px;
		padding-bottom: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// mySqlView.vue?d66c933a